import { useState } from 'react';
import { FiCheck, FiCopy } from 'react-icons/fi';

/**
 * Renders a phone number with a copy-to-clipboard icon beside it.
 * Matches the Figma contact cell design: number + small copy icon.
 */
export default function ContactCell({ number }) {
  const [copied, setCopied] = useState(false);

  function handleCopy(e) {
    e.stopPropagation();
    if (!number) return;
    navigator.clipboard.writeText(number).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    });
  }

  if (!number) return <span className="text-[#8e8e8e]">—</span>;

  return (
    <span className="inline-flex items-center gap-1.5">
      <span className="text-[11px] font-medium text-black">{number}</span>
      <button
        type="button"
        onClick={handleCopy}
        title={copied ? 'Copied!' : 'Copy to clipboard'}
        className="flex h-[14px] w-[14px] shrink-0 items-center justify-center rounded text-[#2196F3] transition hover:text-[#135809]"
      >
        {copied
          ? <FiCheck  className="h-[10px] w-[10px] text-[#28ba12]" />
          : <FiCopy   className="h-[10px] w-[10px]" />}
      </button>
    </span>
  );
}
